import { notificationByIdQuery } from '@/entities/notifications'
import { createModalModel } from '@/shared/lib/model-factories'
import { createEvent, sample } from 'effector'

export const {
  modalOpened: notificationViewModalOpened,
  modalClosed: notificationViewModalClosed,
  $isModalOpened: $isNotificationViewModalOpened,
} = createModalModel()

const notificationViewModalOpenedWithData = createEvent<{ id: string }>()

sample({
  clock: notificationViewModalOpened,
  filter: (params): params is { id: string } => Boolean(params),
  target: notificationViewModalOpenedWithData,
})

sample({
  clock: notificationViewModalOpenedWithData,
  target: notificationByIdQuery.start,
})

sample({
  clock: notificationViewModalClosed,
  target: notificationByIdQuery.reset,
})
